import './kchoppscatering/style';
import FormStructure from './kchoppscatering/form_structure';

export default FormStructure;